<template>
  <div id="TimeField" class="bg-white">
    <van-row>
      <van-col span="4">
        <van-icon name="bars" class="mt-3" size="22px" />
      </van-col>
      <van-col span="16">
        <van-picker
          :columns="TimeArray"
          :visible-item-count="1"
          :default-index="DefaultSelectTime"
          @change="onChangeTime"
        />
      </van-col>
      <van-col span="4">
        <van-icon name="exchange" class="mt-3" size="22px" @click="showTimeField = true" />
      </van-col>
    </van-row>
    <van-popup v-model="showTimeField" position="bottom">
      <div class="p-4">
        <h3>选择场次</h3>
        <van-picker
          class="m-2"
          :columns="TimeArray"
          :visible-item-count="3"
          @change="onChangeTime"
          :default-index="DefaultSelectTime"
        />
        <van-button v-show="false" plain hairline type="info" class="w-75">关闭</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "time-field",
  data() {
    return {
      showTimeField: false,
      DefaultSelectTime: 0,
      TimeArray: []
    };
  },
  methods: {
    getTime() {
      this.TimeArray = [];
      this.getExamList().forEach((element, index) => {
        this.TimeArray.push(element.examNameText);
        if (element.selected == "true") {
          this.DefaultSelectTime = index;
        }
      });
    },
    //选择考试场次
    // eslint-disable-next-line
    onChangeTime: function(picker, value, index) {
      this.setExamTime(value);
      this.getTime();
      this.onCallback();
      this.showTimeField = false;
    },
    onCallback() {
      //this.$toast("数据刷新");
      let callback = function() {};
      this.$emit("callback", callback);
      if (callback) {
        callback;
      }
    }
  },
  created() {
    this.getTime();
  }
};
</script>

<style scoped>
</style>